const MODULE_NAME = 'news';

class NewsController {
	constructor($document) {
		'ngInject';
		this._$document = $document;
	}

	$onInit() {
		this.shareUrl = encodeURIComponent(this._$document[0].URL);
	}
}

angular.module(MODULE_NAME, [])
	.controller('NewsController', NewsController);

export default MODULE_NAME;


// WEBPACK FOOTER //
// ./source/modules/box/news.js